"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicalApiErrorRegistry = void 0;
/**
 * Per-endpoint error registry — which `ClinicalErrorCodes` (plus the
 * generic cross-cutting `VALIDATION_ERROR` every endpoint can return)
 * a specific endpoint can actually respond with. Same pattern
 * `financial-error-registry.ts`/`appointment-error-registry.ts`
 * already established. This is what a `ClinicalOpenApiOperations`
 * entry's `errorCodes` is built from (`../openapi`).
 */
const clinical_error_codes_1 = require("./clinical-error-codes");
const GENERIC_CODES = [clinical_error_codes_1.ClinicalErrorCodes.VALIDATION_ERROR];
function toContract(code) {
    return { code, ...(0, clinical_error_codes_1.getClinicalErrorCatalogEntry)(code) };
}
function endpoint(name, codes) {
    return { endpoint: name, errors: [...codes, ...GENERIC_CODES].map(toContract) };
}
exports.ClinicalApiErrorRegistry = {
    /*
      P0-3 — the clinical worklist read. No endpoint-specific error codes: it is
      a filtered, paginated read, so its only failure modes are the generic
      validation/authorisation ones `endpoint()` already attaches. An empty list
      is a valid result, not an error.
    */
    listEncounters: endpoint('listEncounters', []),
    createEncounter: endpoint('createEncounter', []),
    openEncounter: endpoint('openEncounter', [
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    suspendEncounter: endpoint('suspendEncounter', [clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_INVALID_STATUS_TRANSITION]),
    resumeEncounter: endpoint('resumeEncounter', [clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_INVALID_STATUS_TRANSITION]),
    completeEncounter: endpoint('completeEncounter', [
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_DOCUMENTATION_REQUIRED,
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    closeEncounter: endpoint('closeEncounter', [
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    cancelEncounter: endpoint('cancelEncounter', [clinical_error_codes_1.ClinicalErrorCodes.ENCOUNTER_ALREADY_FINALIZED]),
    createClinicalDocument: endpoint('createClinicalDocument', [clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_TEMPLATE_INVALID]),
    saveClinicalDocumentDraft: endpoint('saveClinicalDocumentDraft', [
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_NOT_DRAFT,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    finalizeClinicalDocument: endpoint('finalizeClinicalDocument', [
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    approveClinicalDocument: endpoint('approveClinicalDocument', [
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_APPROVAL_ROLE_NOT_AUTHORIZED,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    amendClinicalDocument: endpoint('amendClinicalDocument', [clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_DOCUMENT_NOT_FINAL]),
    getClinicalDocumentVersionHistory: endpoint('getClinicalDocumentVersionHistory', []),
    getClinicalDocument: endpoint('getClinicalDocument', []),
    getClinicalDocumentPdf: endpoint('getClinicalDocumentPdf', []),
    getDischargeSummaryForAdmission: endpoint('getDischargeSummaryForAdmission', []),
    createClinicalOrder: endpoint('createClinicalOrder', [
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_INVALID_REFERENCE,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_DUPLICATE_ACTIVE,
    ]),
    signClinicalOrder: endpoint('signClinicalOrder', [
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    signClinicalOrderWithApproval: endpoint('signClinicalOrderWithApproval', [
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_APPROVAL_ROLE_NOT_AUTHORIZED,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_INVALID_STATUS_TRANSITION,
        clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_OPTIMISTIC_LOCK_CONFLICT,
    ]),
    cancelClinicalOrder: endpoint('cancelClinicalOrder', [clinical_error_codes_1.ClinicalErrorCodes.CLINICAL_ORDER_ALREADY_CANCELLED]),
    getPatientClinicalTimeline: endpoint('getPatientClinicalTimeline', []),
    getPatientClinicalWorkflowTimeline: endpoint('getPatientClinicalWorkflowTimeline', []),
    getClinicalAuditTrail: endpoint('getClinicalAuditTrail', []),
    resolveClinicalApprovalChain: endpoint('resolveClinicalApprovalChain', []),
    validateClinicalCoSigner: endpoint('validateClinicalCoSigner', []),
};
//# sourceMappingURL=clinical-error-registry.js.map